import React__default from 'react';
import { isNonRecoverableError, useGetCLByPrescription } from '@grandvisionhq/fun-products';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';
import { useCLEcommContext } from '../context/CLEcommContext.js';
import { mapClientToServerPrescription } from '../components/CLPrescriptionSelector/mappers/map-client-to-server-prescription.js';

const useFetchCLByPrescription = ({ eyeSide  })=>{
    const { clAndSolutionsMaxOrderableQuantity: maxOrderableQuantity  } = useProductDetailContext();
    const { actions , brandKey , triggerToastMessage  } = useCLEcommContext();
    const onSuccess = React__default.useCallback((result)=>{
        const { prescriptionCLProduct  } = result;
        actions.updateQueryResult({
            eyeSide,
            maxOrderableQuantity,
            prescriptionCLProduct
        });
    }, []);
    const onError = React__default.useCallback((result)=>{
        actions.updateQueryResult({
            eyeSide,
            maxOrderableQuantity,
            error: result.error
        });
        if (isNonRecoverableError(result.error)) {
            triggerToastMessage('non-recoverable-error');
        }
    }, []);
    const getCLByPrescription = useGetCLByPrescription({
        onSuccess,
        onError
    });
    const fetchCLByPrescription = React__default.useCallback((columnConfigurations)=>{
        const prescription = mapClientToServerPrescription(columnConfigurations);
        if (prescription) {
            actions.setQueryLoading({
                eyeSide,
                loading: true
            });
            getCLByPrescription({
                brandKey,
                prescription
            });
        }
    }, [
        actions,
        brandKey,
        eyeSide,
        getCLByPrescription
    ]);
    return fetchCLByPrescription;
};

export { useFetchCLByPrescription };
//# sourceMappingURL=use-fetch-cl-by-prescription.js.map
